module.exports = __webpack_public_path__ + "media/assets/images/flags/sk-01875cd23a23fa55e5e5a72aaca7cdcd.svg";